/* THE HOME - refonte cinematique : interactions */
(function () {
  var d = document;
  var root = d.documentElement;
  root.classList.add('cine-js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Reveal au scroll ---------- */
  var io = null;
  function ensureObserver() {
    if (io || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    return io;
  }

  function observe(el) {
    var obs = ensureObserver();
    if (!obs) { el.classList.add('is-in'); return; }
    obs.observe(el);
  }

  function scan(scope) {
    var nodes = (scope || d).querySelectorAll('[data-cine-reveal]:not(.cine-watched)');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.add('cine-watched');
      observe(nodes[i]);
    }
  }

  /* auto-tag des sections natives du theme (pages produit, collection, etc.) */
  function autoTag() {
    var main = d.getElementById('MainContent');
    if (!main) return;
    var sections = main.querySelectorAll(':scope > .shopify-section');
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      if (s.querySelector('.cine')) continue;
      if (!s.hasAttribute('data-cine-reveal')) {
        s.setAttribute('data-cine-reveal', '');
        s.style.setProperty('--cine-delay', '0ms');
      }
    }
    var cards = main.querySelectorAll('.product-grid > li, .product-grid > div, .resource-list__item, .card-gallery');
    for (var j = 0; j < cards.length && j < 60; j++) {
      if (cards[j].hasAttribute('data-cine-reveal')) continue;
      cards[j].setAttribute('data-cine-reveal', '');
      cards[j].style.setProperty('--cine-delay', Math.min(j, 8) * 70 + 'ms');
    }
  }

  /* ---------- 2. Etat scroll (header) ---------- */
  var lastY = -1;
  function onScroll() {
    var y = window.scrollY || window.pageYOffset;
    if (y === lastY) return;
    lastY = y;
    root.classList.toggle('cine-scrolled', y > 40);
    var sticky = d.querySelector('[data-cine-sticky]');
    if (sticky) {
      var hero = d.querySelector('.cine-hero');
      var trigger = hero ? hero.offsetHeight * 0.85 : 700;
      sticky.classList.toggle('is-in', y > trigger);
    }
    var v = d.querySelector('.cine-hero__video');
    if (v && !reduce && y < window.innerHeight) {
      v.style.transform = 'scale(' + (1.04 + y / 9000) + ') translateY(' + (y * 0.13) + 'px)';
    }
  }

  /* ---------- 3. Slider du hero ---------- */
  function initHero() {
    var hero = d.querySelector('[data-cine-hero]');
    if (!hero) return;
    var slides = hero.querySelectorAll('[data-cine-slide]');
    if (slides.length < 1) return;
    var dots = hero.querySelectorAll('[data-cine-dot]');
    var cur = 0;
    var timer = null;

    function paint(n, dir) {
      cur = (n + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === cur);
      }
      for (var k = 0; k < dots.length; k++) {
        dots[k].classList.remove('is-active');
      }
      if (dots[cur]) {
        var dnew = dots[cur].cloneNode(true);
        dots[cur].parentNode.replaceChild(dnew, dots[cur]);
        dots = hero.querySelectorAll('[data-cine-dot]');
        dots[cur].classList.add('is-active');
        bindDots();
      }
      var anim = slides[cur].querySelectorAll('.animate-blur-fade-up');
      for (var a = 0; a < anim.length; a++) {
        var el = anim[a];
        el.style.animation = 'none';
        void el.offsetWidth;
        el.style.animation = '';
      }
      restart();
    }
    function bindDots() {
      var dd = hero.querySelectorAll('[data-cine-dot]');
      for (var i = 0; i < dd.length; i++) {
        (function (idx, node) {
          node.onclick = function () { paint(idx); };
        })(i, dd[i]);
      }
    }
    function restart() {
      if (timer) clearTimeout(timer);
      if (slides.length < 2 || reduce) return;
      timer = setTimeout(function () { paint(cur + 1); }, 7000);
    }

    var prev = hero.querySelector('[data-cine-prev]');
    var next = hero.querySelector('[data-cine-next]');
    if (prev) prev.addEventListener('click', function () { paint(cur - 1); });
    if (next) next.addEventListener('click', function () { paint(cur + 1); });
    bindDots();
    restart();

    hero.addEventListener('mouseenter', function () { if (timer) clearTimeout(timer); });
    hero.addEventListener('mouseleave', restart);

    /* lecture video robuste (iOS / economie de donnees) */
    var vid = hero.querySelector('video');
    if (vid) {
      vid.muted = true;
      vid.setAttribute('muted', '');
      var p = vid.play();
      if (p && p.catch) p.catch(function () {});
      vid.addEventListener('loadeddata', function () { hero.classList.add('cine-video-ready'); });
    }
  }

  /* ---------- 4. Duplication marquee ---------- */
  function initMarquee() {
    var tracks = d.querySelectorAll('[data-cine-marquee]:not(.cine-dup)');
    for (var i = 0; i < tracks.length; i++) {
      var t = tracks[i];
      t.classList.add('cine-dup');
      t.innerHTML = t.innerHTML + t.innerHTML;
    }
  }

  /* ---------- 5. Filet de securite ---------- */
  function safety() {
    setTimeout(function () {
      var hidden = d.querySelectorAll('[data-cine-reveal]:not(.is-in)');
      for (var i = 0; i < hidden.length; i++) {
        var r = hidden[i].getBoundingClientRect();
        if (r.top < window.innerHeight) hidden[i].classList.add('is-in');
      }
    }, 2500);
  }

  function boot() {
    autoTag();
    scan();
    initHero();
    initMarquee();
    onScroll();
    safety();
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  d.addEventListener('shopify:section:load', function () { setTimeout(boot, 60); });
  d.addEventListener('shopify:section:select', function () { setTimeout(boot, 60); });
})();
